import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2;
import { computed, observable, action } from 'mobx';
import { mapInitialStateToStoreState } from "../../utils/store.utils/index.js";
// stores
import { FursanStore } from "../fursan.store/index.js";
import { FursanBulkStore } from "../fursan-bulk.store/index.js";
import { QitafStore } from "../qitaf.store/index.js";
import { MokafaStore } from "../mokafa.store/index.js";
import { QitafBulkStore } from "../qitaf-bulk.store/index.js"; // constants
import { LOYALTY_METHODS } from "../../constants/index.js";
var FURSAN = LOYALTY_METHODS.FURSAN,
  QITAF = LOYALTY_METHODS.QITAF,
  MOKAFAA = LOYALTY_METHODS.MOKAFAA;
/**
 * Loyalty Store
 * @description This is a PaymentApp-specific store that manages payment loyalty programs
 * reward calculations and earn state
 */
export var LoyaltyStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env env object passed to it from composing parent
   */
  function LoyaltyStore(initialState, $env) {
    if (initialState === void 0) {
      initialState = {};
    }
    if ($env === void 0) {
      $env = {};
    }
    this.$env = void 0;
    this.fursanRewards = void 0;
    this.fursanBulkRewards = void 0;
    this.qitafRewards = void 0;
    this.qitafBulkRewards = void 0;
    this.mokafaaRewards = void 0;
    _initializerDefineProperty(this, "selectedLoyaltyToEarn", _descriptor, this);
    /**
     * identifier
     * @description This represents an identifier for the earned loyalty program,
     * and it can mean different things depending on the earned loyalty program:
     *   * for `Qitaf`: it means the associated `STC` mobile number to earn these points with
     *   * for `Fursan`: it means the associated `Fursan` membership number to earn these points with
     *   * for `Wallet`: it is just a dummy number sent from the vertical
     */
    _initializerDefineProperty(this, "earnIdentifier", _descriptor2, this);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.fursanRewards = new FursanStore(initialState.fursanRewards, $env);
    this.fursanBulkRewards = new FursanBulkStore(initialState.fursanBulkRewards, $env);
    this.qitafRewards = new QitafStore(initialState.qitafRewards, $env);
    this.qitafBulkRewards = new QitafBulkStore(initialState.qitafBulkRewards, $env);
    this.mokafaaRewards = new MokafaStore(initialState.mokafaaRewards, $env);
  }
  var _proto = LoyaltyStore.prototype;
  /**
   * earnFursan
   * @description sets `fursan` program is earned or not
   * @param {string} earnIdentifier
   */
  _proto.earnFursan = function earnFursan(earnIdentifier) {
    this.selectedLoyaltyToEarn = FURSAN;
    this.earnIdentifier = earnIdentifier;
  }

  /**
   * earnQitaf
   * @description sets `qitaf` program is earned or not
   * @param {string} earnIdentifier
   */;
  _proto.earnQitaf = function earnQitaf(earnIdentifier) {
    this.selectedLoyaltyToEarn = QITAF;
    this.earnIdentifier = earnIdentifier;
  }

  // /**
  //  * earnWallet
  //  * @description sets `wallet` program is earned or not
  //  * @param {string} earnIdentifier
  //  */
  // @action.bound earnWallet(earnIdentifier) {
  //   this.selectedLoyaltyToEarn = WALLET;
  //   this.earnIdentifier = earnIdentifier;
  // }

  /**
   * earnMokafaa
   * @description sets `mokafaa` program is earned or not
   * @param {string} earnIdentifier
   */;
  _proto.earnMokafaa = function earnMokafaa(earnIdentifier) {
    this.selectedLoyaltyToEarn = MOKAFAA;
    this.earnIdentifier = earnIdentifier;
  }

  /**
   * unEarn
   * @description removes any earned program
   */;
  _proto.unEarn = function unEarn() {
    this.selectedLoyaltyToEarn = '';
    this.earnIdentifier = '';
  }

  /**
   * update initial state
   * @param {Object} initialState
   */;
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  _createClass(LoyaltyStore, [{
    key: "hasEarnIdentifier",
    get:
    /**
     * hasEarnIdentifier
     * @description checks whether store has an earn identifier or not
     * @returns {boolean}
     */
    function get() {
      return !!this.earnIdentifier;
    }

    /**
     * canEarnFursan
     * @description checks whether user can earn `fursan` program rewards or not
     * @returns {boolean}
     */
  }, {
    key: "canEarnFursan",
    get: function get() {
      return this.fursanRewards.canEarn || this.fursanBulkRewards.canEarn;
    }

    /**
     * canEarnQitaf
     * @description checks whether user can earn `qitaf` program rewards or not
     * @returns {boolean}
     */
  }, {
    key: "canEarnQitaf",
    get: function get() {
      return this.qitafRewards.canEarn || this.qitafBulkRewards.canEarn;
    }

    /**
     * canEarnMokafaa
     * @description checks whether user can earn `mokafaa` program rewards or not
     * @returns {boolean}
     */
  }, {
    key: "canEarnMokafaa",
    get: function get() {
      return this.mokafaaRewards.canEarn;
    }

    /**
     * mokafa reward rule object
     * @return {object}
     */
  }, {
    key: "mokafaRuleObject",
    get: function get() {
      return this.mokafaaRewards.ruleObject;
    }

    /**
     * canEarnSomething
     * @description checks whether user can earn some points from any loyalty program
     * @returns {boolean}
     */
  }, {
    key: "canEarnSomething",
    get: function get() {
      return this.canEarnFursan || this.canEarnQitaf ||
      // this.earnedWallet ||
      this.earnedMokafaa;
    }

    /**
     * cannotEarn
     * @description checks whether user cannot earn any points from any loyalty program
     * @returns {boolean}
     */
  }, {
    key: "cannotEarn",
    get: function get() {
      return !this.canEarnSomething;
    }

    /**
     * fursanRewardValue
     * @description returns reward value for `fursan`
     * @returns {number}
     */
  }, {
    key: "fursanRewardValue",
    get: function get() {
      if (this.fursanRewards.canEarn) return this.fursanRewards.rewardValue;
      if (this.fursanBulkRewards.canEarn) return this.fursanBulkRewards.rewardValuesSum;
      return 0;
    }

    /**
     * qitafRewardValue
     * @description returns reward value for `qitaf`
     * @returns {number}
     */
  }, {
    key: "qitafRewardValue",
    get: function get() {
      if (this.qitafRewards.canEarn) return this.qitafRewards.rewardValue;
      if (this.qitafBulkRewards.canEarn) return this.qitafBulkRewards.rewardValuesSum;
      return 0;
    }

    /**
     * mokafaaRewardValue
     * @description returns reward value for `mokafaa`
     * @returns {number}
     */
  }, {
    key: "mokafaaRewardValue",
    get: function get() {
      if (this.mokafaaRewards.canEarn) return this.mokafaaRewards.rewardValue;
      return 0;
    }

    /**
     * earnedFursan
     * @description checks whether `fursan` program is earned or not
     * @returns {boolean}
     */
  }, {
    key: "earnedFursan",
    get: function get() {
      return this.selectedLoyaltyToEarn === FURSAN && this.hasEarnIdentifier && this.canEarnFursan;
    }

    /**
     * earnedQitaf
     * @description checks whether `qitaf` program is earned or not
     * @returns {boolean}
     */
  }, {
    key: "earnedQitaf",
    get: function get() {
      return this.selectedLoyaltyToEarn === QITAF && this.hasEarnIdentifier && this.canEarnQitaf;
    }

    // /**
    //  * earnedWallet
    //  * @description checks whether `wallet` program is earned or not
    //  * @returns {boolean}
    //  */
    // @computed get earnedWallet() {
    //   return (
    //     this.selectedLoyaltyToEarn === WALLET &&
    //     this.hasEarnIdentifier &&
    //     this.canEarnWallet
    //   );
    // }

    /**
     * earnedMokafaa
     * @description checks whether `mokafaa` program is earned or not
     * @returns {boolean}
     */
  }, {
    key: "earnedMokafaa",
    get: function get() {
      return this.selectedLoyaltyToEarn === MOKAFAA && this.hasEarnIdentifier && this.canEarnMokafaa;
    }

    /**
     * earnedSomething
     * @description checks whether * program is earned or not
     * @returns {boolean}
     */
  }, {
    key: "earnedSomething",
    get: function get() {
      return !!this.selectedLoyaltyToEarn && this.hasEarnIdentifier;
    }

    /**
     * earnedNothing
     * @description checks whether no program is earned
     * @returns {boolean}
     */
  }, {
    key: "earnedNothing",
    get: function get() {
      return !this.earnedSomething;
    }
  }]);
  return LoyaltyStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedLoyaltyToEarn", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "earnIdentifier", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasEarnIdentifier", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasEarnIdentifier"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarnFursan", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarnFursan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarnQitaf", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarnQitaf"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarnMokafaa", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarnMokafaa"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mokafaRuleObject", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mokafaRuleObject"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarnSomething", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarnSomething"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cannotEarn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cannotEarn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fursanRewardValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fursanRewardValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "qitafRewardValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "qitafRewardValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mokafaaRewardValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mokafaaRewardValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnedFursan", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "earnedFursan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnedQitaf", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "earnedQitaf"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnedMokafaa", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "earnedMokafaa"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnedSomething", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "earnedSomething"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnedNothing", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "earnedNothing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnFursan", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "earnFursan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnQitaf", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "earnQitaf"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earnMokafaa", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "earnMokafaa"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unEarn", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "unEarn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class));